<template>
  <div class="most-share-post-item">
    <div class="post-meta">
      <div class="meta-categories">
        <router-link :to="'/articles?channel=' + datas.orgchannel">{{ datas.channel }}</router-link>
      </div>
      <div class="meta-date">
        <span>{{ datas.createdat }}</span>
      </div>
    </div>
    <h3 class="title">
      <router-link :to="`/articles/${ datas.id }`">{{ datas.title }}</router-link>
    </h3>
    <ul>
      <li><i class="far fa-eye"></i> {{ datas.view }}</li>
    </ul>
    <div class="count">
      <span>{{ count }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    datas: {
      type: Object,
    },
    count: {
      type: Number,
    },
  },
};
</script>

<style></style>
